import * as React from "react";

import { SharedTemplateDetailsModal } from "@editor/components/templateLibrary/SharedTemplateDetailsModal";

import { useNavigate } from "react-router-dom";

import EmptyLayout from "./EmptyLayout";

const ShareTemplateLayout = () => {
  const navigate = useNavigate();
  return (
    <EmptyLayout>
      <SharedTemplateDetailsModal
        onClose={() => {
          navigate("/");
        }}
      />
    </EmptyLayout>
  );
};

export default ShareTemplateLayout;
